export const getStories = async (limit, offset = 0) => {
  const FIELDS =
    "id,authors,headline,slug,hero-image-s3-key,hero-image-metadata,published-at,first-published-at,last-published-at,alternative,author-name,author-id,sections,story-template,url,read-time";

  const { stories } = await (
    await fetch(`/api/v1/stories?fields=${FIELDS}&limit=${limit}&offset=${offset}&sort=latest-published`)
  ).json();

  return stories;
};
